export const VISITOR_UUID = "VISITOR_UUID";
export const CURRENCY = "_currency";
export const LANG = "_lang";
export const COUNTRY = "_country";
export const TIMEZONE = "_timezone";
